module.exports = __webpack_public_path__ + "static/NitroPack-c35187fd1dde84adad79b0461117d4f8.svg";